var map = {
	"./bookmark-blue.svg": 630,
	"./buildings-blue.svg": 631,
	"./buildings-gray.svg": 632,
	"./checkbox.svg": 633,
	"./cloud-inactive.svg": 40,
	"./cloud.svg": 634,
	"./document.svg": 635,
	"./edit-inactive.svg": 28,
	"./edit.svg": 636,
	"./info.svg": 285,
	"./no-print.svg": 286,
	"./opcje.svg": 210,
	"./question.svg": 284,
	"./settings.svg": 287,
	"./standard.svg": 293,
	"./student-blue.svg": 637,
	"./student-gray.svg": 638,
	"./table.svg": 639,
	"./text-field.svg": 640,
	"./vector.svg": 294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 629;